import React, { useState } from "react";
import { Avatar, Box, Button, Collapse, IconButton, List, ListItem, ListItemAvatar, ListItemText, makeStyles, Typography } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { Add, Delete, ExpandLess, ExpandMore, Remove } from "@material-ui/icons";
import { deleteInventoryItem, updateInventoryItemQty } from "../../redux/reducers/inventory/inventoryReducer";
import config from "../../config/config";
import { getSubCategoryCount } from "./InventoryHelper";

const useStyles = makeStyles((theme) => ({
    tableCategoryItems: {
        border: "1px solid #BDBDBD",
        borderRadius: "8px",
        backgroundColor: "#FFFFFF",
        marginBottom: "8px",
        overflow: "hidden",
        transition: "all 0.3s ease-in-out",
    },
    tableCategoryItemsList: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        cursor: "pointer",
        backgroundColor: "#FFFFFF",
        paddingTop: 2,
        paddingBottom: 2,
    },
    iconColor: {
        color: "#000000DE",
    },
    iconBox: {
        display: "flex",
        alignItems: "center",
        gap: 10,
        background: "#FFCACA",
        borderRadius: 6,
    },
    subCategoryCount: {
        marginLeft: 8,
        marginTop: 1,
        background: "#ede9e9",
        padding: "1px 4px",
        fontSize: 10,
        borderRadius: 4,
    },
}));

const CategoryItems = ({ selectedCategory }) => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const [openIndex, setOpenIndex] = useState(null);

    const inventoryData = useSelector((state) => state.inventoryInfo);

    const handleToggle = (id) => {
        setOpenIndex(openIndex === id ? null : id);
    };

    const updateQtyFn = (operation, selectedIndex) => {
        const params = {
            operation: operation,
            path: [
                "inventory",
                selectedIndex.mainIndex,
                "category",
                selectedIndex.subIndex,
                "items",
                selectedIndex.itemIndex,
            ],
        };
        dispatch(updateInventoryItemQty(params));
    };

    const deleteQtyFn = (mainCategoryId, subCategoryId, itemId) => {
        const params = {
            itemId: itemId,
            pathKeyId: {
                mainCategoryId: mainCategoryId,
                subCategoryId: subCategoryId,
            },
        };
        dispatch(deleteInventoryItem(params));
    };

    return (
        <List>
            {inventoryData.get("inventory").map((category, mainIndex) => {
                if (category.get("id") !== selectedCategory) return null;

                return category.get("category").map((subCategory, subIndex) => (
                    <Box
                        key={`${selectedCategory}_${subCategory.get("id")}`}
                        className={classes.tableCategoryItems}
                    >
                        <ListItem
                            className={classes.tableCategoryItemsList}
                            onClick={() => handleToggle(subCategory.get("id"))}
                        >
                            <ListItemAvatar style={{ minWidth: 40 }}>
                                <Avatar
                                    src={`${config.customerPortal}images/items_v3/${subCategory.get("name")}.png`}
                                    alt={subCategory.get("name")}
                                    style={{ width: 24, height: 24 }}
                                    variant="square"
                                />
                            </ListItemAvatar>
                            <ListItemText
                                primary={
                                    <Box className="d-flex align-items-center">
                                        <Typography style={{ fontWeight: 600 }}>
                                            {subCategory.get("displayName")}
                                        </Typography>
                                        {getSubCategoryCount(subCategory) > 0 && (
                                            <Typography className={classes.subCategoryCount} variant="caption">
                                                {getSubCategoryCount(subCategory)} Added
                                            </Typography>
                                        )}
                                    </Box>
                                }
                            />
                            <IconButton size="small">
                                {openIndex === subCategory.get("id") ? <ExpandLess /> : <ExpandMore />}
                            </IconButton>
                        </ListItem>
                        <Collapse in={openIndex === subCategory.get("id")} timeout="auto" unmountOnExit>
                            <List style={{ borderTop: "1px solid #BDBDBD" }}>
                                {subCategory.get("items").map((item, itemIndex) => (
                                    <ListItem key={item.get("id")} className="py-1">
                                        <ListItemText
                                            primary={
                                                <Typography style={{ fontWeight: 500 }}>
                                                    {item.get("displayName")}
                                                </Typography>
                                            }
                                        />

                                        {item.get("qty") > 0 ? (
                                            <Box className={classes.iconBox}>
                                                {item.get("qty") === 1 ? (
                                                    <IconButton
                                                        title="Delete Item"
                                                        size="small"
                                                        onClick={() => deleteQtyFn(category.get("id"), subCategory.get("id"), item.get("id"))}
                                                    >
                                                        <Delete className={classes.iconColor} />
                                                    </IconButton>
                                                ) : (
                                                    <IconButton
                                                        title="Remove Item"
                                                        size="small"
                                                        onClick={() => updateQtyFn("decrement", { mainIndex, subIndex, itemIndex })}
                                                    >
                                                        <Remove className={classes.iconColor} />
                                                    </IconButton>
                                                )}
                                                <Typography style={{ fontWeight: 600 }}>
                                                    {item.get("qty")}
                                                </Typography>
                                                <IconButton
                                                    title="Add Item"
                                                    size="small"
                                                    onClick={() => updateQtyFn("increment", { mainIndex, subIndex, itemIndex })}
                                                >
                                                    <Add className={classes.iconColor} />
                                                </IconButton>
                                            </Box>
                                        ) : (
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                size="small"
                                                style={{ background: "#FFCACA", color: "#000000DE" }}
                                                onClick={() => updateQtyFn("increment", { mainIndex, subIndex, itemIndex })}
                                            >
                                                Add
                                            </Button>
                                        )}
                                    </ListItem>
                                ))}
                            </List>
                        </Collapse>
                    </Box>
                ));
            })}
        </List>
    );
};

export default CategoryItems;